module.exports = require('xmlhttprequest').XMLHttpRequest
